import React, { useEffect, useState } from 'react';
import {
  IonContent,
  IonPage,
  IonLoading,
  IonButton,
  IonIcon
} from '@ionic/react';
import { RouteComponentProps } from 'react-router';
import { Laboratory } from '../models';
import LaboratoryRepository from '../repositories/LaboratoryRepository';
import {
  APPOINTMENT_ROUTE,
  COVID_APPOINTMENT_ROUTE
} from '../navigators/AppStackNavigator';
import AccountHeader from '../components/AccountHeader';
import AppHeader from '../components/AppHeader';
import { Specialty } from '../models/Laboratory';
import './LaboratoryGroupDispatch.scss';

enum SpecialtyName {
  Covid = 'COVID',
  Biology = 'Biologie générale',
  Hormonology = 'Hormonologie'
}

const getIconName = (specialityName: string): string => {
  switch (specialityName) {
    case SpecialtyName.Covid:
      return 'covid';
    case SpecialtyName.Biology:
      return 'tube';
    case SpecialtyName.Hormonology:
      return 'female';
    default:
      return '';
  }
};

const getCustomSpecialityName = (specialityName: string) => {
  switch (specialityName) {
    case SpecialtyName.Covid:
      return 'Un test PCR COVID-19';
    case SpecialtyName.Biology:
      return 'Une analyse de biologie';
    case SpecialtyName.Hormonology:
      return "Une analyse d'hormonologie";
    default:
      return specialityName;
  }
};
const getIcon = (speciality: Specialty) => {
  const iconName = getIconName(speciality.name);
  if (iconName) {
    return <IonIcon src={require(`../assets/icons/${iconName}.svg`)} />;
  } else {
    return null;
  }
};

const getNote = (speciality: Specialty) => {
  switch (speciality.name) {
    case SpecialtyName.Biology:
      return <small>(hors test PCR COVID)</small>;
    case SpecialtyName.Covid:
    default:
      return null;
  }
};

const LaboratoryGroupDispatch: React.FC<
  RouteComponentProps<{ laboratoryGroupSlug: string }>
> = ({ match }) => {
  const [laboratories, setLaboratories] = useState<Laboratory[]>();
  const [welcomeMessage, setWelcomeMessage] = useState('');
  const [welcomeTitle, setWelcomeTitle] = useState('');
  const [specialty, setSpecialty] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function getInfos() {
      setIsLoading(true);

      const group = await LaboratoryRepository.getLaboratoriesByGroupSlug(
        match.params.laboratoryGroupSlug
      ).finally(() => {
        setIsLoading(false);
      });

      setWelcomeMessage(group.welcomeMessage || '');
      setWelcomeTitle(group.welcomeTitle || '');
      setLaboratories(group.laboratories);
      setSpecialty(group.specialty || '');
    }

    getInfos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const logo = (
    <img
      src={require('../assets/images/logo-unilabs-le-pass.svg')}
      alt="Le Pass"
    />
  );
  const customWelcomeTitle = (
    <div className="LaboratoryGroupDispatch__title">
      <div className="flex LaboratoryGroupDispatch__logo">{logo}</div>
      <div dangerouslySetInnerHTML={{ __html: welcomeTitle }} />
    </div>
  );
  return (
    <IonPage>
      <IonLoading isOpen={isLoading} />
      <AppHeader />
      <IonContent class="ion-padding LaboratoryGroupDispatch">
        <div className="wrapper wrapper--medium wrapper--stretch wrapper--centered-md">
          <div className="ion-hide-lg-up">
            <AccountHeader />
          </div>
          <div className="home-card">
            <header className="home-card__header ion-margin-bottom">
              <div className="home-card__header__title ion-margin-bottom">
                {welcomeTitle ? customWelcomeTitle : <h1>Bienvenue sur</h1>}
                {!welcomeTitle && logo}
              </div>
              {welcomeMessage ? (
                <div
                  dangerouslySetInnerHTML={{ __html: welcomeMessage }}
                  className="home-card__intro"
                />
              ) : null}
            </header>
            <div className="home-card__buttons">
              {laboratories?.map((laboratory, i) => (
                <div
                  key={laboratory.id}
                  className={
                    i <
                    laboratories.length -
                      (laboratories.length % 2 === 0 ? 2 : 1)
                      ? 'ion-margin-bottom'
                      : ''
                  }
                >
                  <IonButton
                    routerLink={
                      laboratory.covid
                        ? `${COVID_APPOINTMENT_ROUTE}/laboratoire/${laboratory.slug}`
                        : `${APPOINTMENT_ROUTE}/laboratoire/${laboratory.slug}`
                    }
                    expand="block"
                    size="large"
                    color="primary"
                    class="large"
                    routerDirection="forward"
                    onClick={() => {}}
                  >
                    <div className="home-card__inner-button">
                      {getIcon(laboratory.specialities[0])}
                      <span>
                        {laboratory.specialities.length && !specialty
                          ? laboratory.specialities.map(
                              (speciality: Specialty) => (
                                <span key={speciality.id}>
                                  {getCustomSpecialityName(speciality.name)}
                                </span>
                              )
                            )
                          : laboratory.name}
                        {getNote(laboratory.specialities[0])}
                      </span>
                    </div>
                  </IonButton>
                </div>
              ))}
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default LaboratoryGroupDispatch;
